import { DeviceTraceModel } from '@em/models/restapi/DeviceTrace.Model';
import { CollectionModel } from '@shared/models/restapi/Collection.Model';

export class DeviceTraceCollectionModel extends CollectionModel<DeviceTraceModel> {
    public constructor() {
        super(DeviceTraceModel);
    }
}
